import InstitutionLogo from '@/components/cashflow/InstitutionLogo';
import { RenderCellProps } from '@/components/cashflow/transactions/TableRow';
import { FlexRow } from '@/components/common/Flex';
import { EyeOff } from '@/components/common/icons';
import { Box, Tooltip } from '@chakra-ui/react';
import { isSingleplayer, useCurrentUser } from '@common/react/user';

const AccountCell = ({ transactionEntry }: RenderCellProps) => {
    const currentUser = useCurrentUser();

    const avatarBadgeProps = {
        isVisible: !isSingleplayer(currentUser),
        isMine: transactionEntry.financialEntity.isMine,
        isJoint: !!transactionEntry.financialEntity.jointOwnerPartnershipId,
    };

    return (
        <FlexRow
            mt={-0.5}
            ml={-1}
            opacity={transactionEntry.isPending ? 0.5 : 1}
        >
            <Box w={8} borderRadius="full">
                <InstitutionLogo
                    financialEntity={transactionEntry.financialEntity}
                    avatarBadge={avatarBadgeProps}
                    showTooltip
                />
            </Box>
            {transactionEntry.isHidden && (
                <Tooltip label="Hidden from spending & cashflow">
                    <Box ml={2} mr={2} mt={'5px'}>
                        <EyeOff color="gray.800" />
                    </Box>
                </Tooltip>
            )}
        </FlexRow>
    );
};

export default AccountCell;
